// SettingsMenuDefaultGeojsonStyle.js
import React from "react";
import {
  ColorPicker,
  createListCollection,
  Field,
  HStack,
  Input,
  parseColor,
  Select,
  Separator,
  SimpleGrid,
  Text,
  useSelectContext,
} from "@chakra-ui/react";
import { rgbaToHex, saveToCache } from "../../../utilies/Utility";
import Type from "../../../utilies/Types";
import { useAppStore } from "../../../context/store";

function SettingsMenuDefaultGeojsonStyle() {
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const setDefaultGeojsonStyle = useAppStore.getState().setDefaultGeojsonStyle;

  const styleTypeOption = createListCollection({
    items: [
      { name: "Solid" },
      { name: "Dashed" },
      { name: "Dotted" },
    ],
    itemToString: (item) => item.name,
    itemToValue: (item) => item.name,
  });

  const TypeSelectValue = () => {
    const select = useSelectContext();
    const items = select.selectedItems;
    if (items.length !== 0) {
      const { name } = items[0];
      return (
        <Select.ValueText placeholder="Select member">
          <HStack>{name}</HStack>
        </Select.ValueText>
      );
    }
  };

  return (
    <>
      <SimpleGrid columns={2} gap={2}>
        <Select.Root
          collection={styleTypeOption}
          size="sm"
          mb={2}
          value={[defaultGeojsonStyle.defaultStyle]}
          positioning={{ sameWidth: true }}
          onValueChange={(v) => {
            setDefaultGeojsonStyle((prevStyle) => ({
              ...prevStyle,
              defaultStyle: v.value[0],
            }));
            saveToCache(Type.STORAGE.DEFAULT_GEOJSON_STYLE, {
              ...defaultGeojsonStyle,
              defaultStyle: v.value[0],
            });
          }}
        >
          <Select.HiddenSelect />
          <Select.Label>Style</Select.Label>
          <Select.Control>
            <Select.Trigger>
              <TypeSelectValue />
            </Select.Trigger>
            <Select.IndicatorGroup>
              <Select.Indicator />
            </Select.IndicatorGroup>
          </Select.Control>
          <Select.Positioner>
            <Select.Content>
              {styleTypeOption.items.map((item) => (
                <Select.Item item={item} key={item.name} justifyContent="flex-start">
                  {item.name}
                  <Select.ItemIndicator />
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Positioner>
        </Select.Root>

        <Field.Root mb={2}>
          <Field.Label>Stroke Width</Field.Label>
          <Input
            placeholder="Enter Line Width"
            type="number"
            value={defaultGeojsonStyle.defaultLineWidth}
            onChange={(v) => {
              setDefaultGeojsonStyle((prevStyle) => ({
                ...prevStyle,
                defaultLineWidth: parseInt(v.target.value),
              }));
              saveToCache(Type.STORAGE.DEFAULT_GEOJSON_STYLE, {
                ...defaultGeojsonStyle,
                defaultLineWidth: parseInt(v.target.value),
              });
            }}
          />
        </Field.Root>

        <ColorPicker.Root
          value={parseColor(defaultGeojsonStyle.defaultFillColor)}
          onValueChange={(v) => {
            setDefaultGeojsonStyle((prevStyle) => ({
              ...prevStyle,
              defaultFillColor: rgbaToHex(v.valueAsString),
            }));
            saveToCache(Type.STORAGE.DEFAULT_GEOJSON_STYLE, {
              ...defaultGeojsonStyle,
              defaultFillColor: rgbaToHex(v.valueAsString),
            });
          }}
        >
          <ColorPicker.HiddenInput />
          <ColorPicker.Label>Fill Color</ColorPicker.Label>
          <ColorPicker.Control>
            <ColorPicker.Input />
            <ColorPicker.Trigger />
          </ColorPicker.Control>
          <ColorPicker.Positioner>
            <ColorPicker.Content>
              <ColorPicker.Area />
              <HStack>
                <ColorPicker.EyeDropper size="xs" variant="outline" />
                <ColorPicker.Sliders />
              </HStack>
            </ColorPicker.Content>
          </ColorPicker.Positioner>
        </ColorPicker.Root>

        <ColorPicker.Root
          value={parseColor(defaultGeojsonStyle.defaultOutlineColor)}
          onValueChange={(v) => {
            setDefaultGeojsonStyle((prevStyle) => ({
              ...prevStyle,
              defaultOutlineColor: rgbaToHex(v.valueAsString),
            }));
            saveToCache(Type.STORAGE.DEFAULT_GEOJSON_STYLE, {
              ...defaultGeojsonStyle,
              defaultOutlineColor: rgbaToHex(v.valueAsString),
            });
          }}
        >
          <ColorPicker.HiddenInput />
          <ColorPicker.Label>Outline Color</ColorPicker.Label>
          <ColorPicker.Control>
            <ColorPicker.Input />
            <ColorPicker.Trigger />
          </ColorPicker.Control>
          <ColorPicker.Positioner>
            <ColorPicker.Content>
              <ColorPicker.Area />
              <HStack>
                <ColorPicker.EyeDropper size="xs" variant="outline" />
                <ColorPicker.Sliders />
              </HStack>
            </ColorPicker.Content>
          </ColorPicker.Positioner>
        </ColorPicker.Root>
      </SimpleGrid>

      <Separator mb={1} mt={3} />
      <Text>These settings are saved automatically</Text>
    </>
  );
}

export default SettingsMenuDefaultGeojsonStyle;